import React from "react";

const SentimentBadge = ({ sentiment }) => {
  return (
    <div
      style={{
        fontSize: "12px",
        padding: "2px 10px",
        borderRadius: "10px",
        color: "white",
        background:
          sentiment === "Positive"
            ? "rgb(69, 170, 67)"
            : sentiment === "Negative"
            ? "rgb(233, 56, 72)"
            : "rgb(119,119,119)",
      }}
    >
      <p>{sentiment}</p>
    </div>
  );
};

export default SentimentBadge;
